<template>
<div class="component powered-by">
  <div class="row no-gutters justify-content-between align-items-center">
    <div class="col">
      <i18n-picker :light="true"></i18n-picker>
    </div>
    <a class="col text-right" target="_blank" href="/" v-if="card.downloadAPP">
      <img src="../../assets/img/powered-by.svg" alt="Ocard"><br>
    </a>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

import Mixin from '@/mixins';

import I18nPicker from '@/components/I18nPicker.vue';

export default {
  name: 'Powered-by',
  mixins: [Mixin],
  components: {
    I18nPicker,
  },
  computed: {
    ...mapState([
      'card',
    ]),
  },
};
</script>

<style lang="sass" scoped>
.powered-by
  padding: 25px 15px
  flex-grow: 1
  display: flex
  flex-direction: column
  justify-content: flex-end

  color: #757679
  font-size: 0.6669rem
  font-weight: bold
  letter-spacing: 1px

.btn
  color: #B0BEC5
  font-size: 0.6669rem
  font-weight: bold
</style>
